import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { KeyboardArrowDown as ChevronDownIcon } from '@mui/icons-material';
const Dropdown = ({ children, options = [], onSelect, placeholder = 'Select option', disabled = false, className, sx }) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedValue, setSelectedValue] = useState('');
    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (value, label) => {
        setSelectedValue(label);
        onSelect?.(value);
        handleClose();
    };
    const isOpen = Boolean(anchorEl);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { className: className, onClick: handleClick, sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: theme.spacing(0.75, 2),
                    backgroundColor: theme.palette.primary.main + '14',
                    color: theme.palette.primary.darker,
                    borderRadius: theme.spacing(1),
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    border: 'none',
                    minHeight: 32,
                    opacity: disabled ? 0.6 : 1,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: disabled
                            ? theme.palette.primary.main + '14'
                            : theme.palette.primary.main,
                        color: disabled ? theme.palette.primary.darker : theme.palette.common.white,
                        ...(disabled
                            ? {}
                            : {
                                '& .MuiSvgIcon-root': {
                                    color: theme.palette.common.white
                                }
                            })
                    },
                    ...sx
                }, children: [_jsx(Typography, { sx: {
                            fontSize: '14px',
                            fontWeight: 500,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            flex: 1
                        }, children: selectedValue || children || placeholder }), _jsx(ChevronDownIcon, { sx: {
                            fontSize: 16,
                            color: 'inherit',
                            transition: 'transform 0.2s ease-in-out',
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            marginLeft: theme.spacing(1)
                        } })] }), _jsx(Menu, { anchorEl: anchorEl, open: isOpen, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                }, PaperProps: {
                    sx: {
                        mt: 1,
                        minWidth: 200,
                        borderRadius: theme.spacing(1),
                        boxShadow: theme.shadows[4],
                        border: `1px solid ${theme.palette.divider}`,
                        '& .MuiMenuItem-root': {
                            padding: theme.spacing(1, 2),
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover
                            }
                        }
                    }
                }, children: options.map((option, index) => (_jsx(MenuItem, { onClick: () => handleSelect(option.value, option.label), sx: {
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover
                        }
                    }, children: _jsx(Typography, { sx: {
                            fontSize: '14px',
                            fontWeight: 500,
                            color: theme.palette.text.primary
                        }, children: option.label }) }, index))) })] }));
};
export default Dropdown;
